import React from 'react';
import Lottie from 'lottie-react';
import ss from './images/seniorspray_round_border.png';
//import grannyKnee from './images/ggkneepain.png';
//import grannyKnee from './images/granny.gif';
//<img src={grannyKnee} className='ggimage' alt='elderly woman with knee pain' />
import grannyAnimate from './granny_animation.json';

import PainCards from './PainCards';


import {Row, Col} from 'react-bootstrap';


export default function Welcome() {
	return (
	<>
	  	<meta name="description" content="All-natural 25-oil Relief Spray for pain, mobility & wellness. Helps with arthritis, inflammation, migraines, anxiety & more?safe for all ages." />
  		<meta name="keywords" content="natural relief spray, arthritis relief, pain relief, inflammation, mobility support, neuropathy, migraines, anxiety, muscle stiffness, natural healing oils, chemical free spray" />
  		<meta name="author" content="Senior Spray" />
		<div id='home'>
		<br />
		<Row className='text-center'>
		<Col>
		<img src={ss} style={{width: '250px'}} alt='Senior Spray Bottle' />
		</Col>
		</Row>
		<br />
		<p className='welcomeBold' fontWeight='bold' style={{ color: "blue"}}  >
		Welcome to our site with the only "Go to Everything Relief Spray". Most anything from A to Z when liberally applied  will result in fast effective acting relief.  Our pressure point meridian specific application spots sprayed onto the body provide invigorating healing renewal.  This proprietary blend of <b style={{color: 'green'}}>25 plant / flower</b> pure oils from nature is used for a variety of applications.  Middle agers & seniors alike report our 100% natural spray has added improved quality of life relief for both intermittent mishaps & more serious debilitating ailments affecting mobility & day to day ease of movement.  All natural & chemical free, it's something every household should have because of user friendly effectiveness for all age groups including children.
		</p>
		<PainCards />
		<br />
		<p className='purple'>
		 <br /><br/ >
			<Lottie animationData={grannyAnimate} loop={true} className='ggimage' />
			<b style={{fontSize: 16}}>Arthritis, all kinds Osteo or Rheumatoid, chronic inflammation,</b> Muscle tension, stiffness, tightness, sciatica, carpal tunnel, neuropathy, sinus congestion, asthma, allergies, colds / flu / virus, nerve damage or pain, sweling, recent injuries (sprains or broken bones) rotator cuff injury, shoulder pain, hand pain or arthritis, improves poor circulation, varicose veins, bug bites/stings, restless leg, hyperactivity, migraines, regular headaches, monthly cramps, pulsing / throbbing aching joints, lactic acid buildup after strenuous activities, mobility issues (stairs) toothaches, TMJ jaw pain, sore throats, laryngitis. Aromatherapy also affects your brain chemistry & psyche so is also great for emotional issues coupled with hempseed oil for anxiety, nervousness, jittery, by providing calming relief to your nervous & parasypathetic nervous system.  Vagus nerve activation inclusive with our amazing aroma blend that the nervous system responds to immediately! Helps with Anxiety.
</p>
		</div>
	</>
	);
}
